import {Col, Row} from 'react-bootstrap-v5'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import {imageBaseUrl} from 'src/cms/helpers/constants'

// Backend setting that shows the Prabhu careers applicant fields (API: CareerApplicantExtras)
export const CAREER_EXTRA_FIELDS_SETTING = 'careerApplicantExtraFields'

export const APPLICATION_TYPES = [
  {value: 'job', label: 'Job Resume'},
  {value: 'talent', label: 'Talent Hunt'},
  {value: 'trainee', label: 'Trainee'},
]

const LABELS: Record<string, string> = {
  applicationTypeName: 'Application Type',
  appliedDesignation: 'Applied Designation',
  immediateContactName: 'Immediate Contact Name',
  immediateContactRelation: 'Immediate Contact Relation',
  immediateContactMobile: 'Immediate Contact Mobile',
  relativeName: 'Relative At Bank',
  relativeBranchName: 'Relative Branch',
  relativeEmail: 'Relative Email',
  relativePhone: 'Relative Phone',
  coreBanking: 'Core Banking',
  experienceInNetworking: 'Experience In Networking',
  experienceInDomain: 'Experience In Domain',
  expectedSalary: 'Expected Salary',
  termsAcceptedAt: 'Terms Accepted At',
  // Siddhartha careers
  appliedProvinceName: 'Applied Province',
  appliedDistrictName: 'Applied District',
  appliedDepartment: 'Applied Department',
  relativeDepartmentName: 'Relative Department',
  experienceInIt: 'Experience In IT',
  skills: 'Skills',
  licenseType: 'Licence Type',
  willingToRelocate: 'Willing To Relocate',
  preferredCenters: 'Preferred Centres',
}
const FILES: Record<string, string> = {
  recommendationLetter: 'Recommendation Letter',
  equivalenceCertificate: 'Equivalence Certificate',
  membershipCertificate: 'Membership Certificate',
  equivalenceLetter: 'Equivalence Letter',
}
const ROWS: Record<string, string> = {
  educations: 'Education',
  trainings: 'Training',
  recentExperiences: 'Recent Experience',
  currentExperiences: 'Current Experience',
  references: 'Reference',
}
const ROW_LABELS: Record<string, string> = {
  degreeName: 'Degree Name',
  yearOrSemester: 'Year / Semester',
  duration: 'Duration',
  completionYear: 'Completion Year',
  reasonForLeaving: 'Reason For Leaving',
  branch: 'Branch / Department',
  designation: 'Title / Position',
}

const fileLink = (path?: string) =>
  path ? (
    <a target='_blank' rel='noreferrer' href={imageBaseUrl + '/' + path}>
      View
    </a>
  ) : null

// "Additional Details" block of the applicant detail modals; renders nothing unless the setting is on
const CareerDetails = ({details}: {details?: Record<string, any> | null}) => {
  const enabled = checkBackendSetting(CAREER_EXTRA_FIELDS_SETTING)
  if (!enabled || !details) return null

  const address = (key: string, label: string) =>
    details[key] ? (
      <Col md={3} className='mt-3'>
        {label}: {[details[key].localBody, details[key].houseNumber].filter(Boolean).join(', ')}
      </Col>
    ) : null

  return (
    <div data-cy='career-details'>
      <h5 className='mt-5'>Additional Details</h5>
      <Row>
        {Object.keys(LABELS)
          .filter((key) => details[key])
          .map((key) => (
            <Col md={3} className='mt-3' key={key}>
              {LABELS[key]}: {details[key]}
            </Col>
          ))}
        {details.preferredBranches?.length > 0 && (
          <Col md={6} className='mt-3'>
            Applied Branches: {details.preferredBranches.map((b: any) => b.name || b.id).join(', ')}
          </Col>
        )}
        {address('permanentAddress', 'Permanent Local Body / House No.')}
        {address('temporaryAddress', 'Present Local Body / House No.')}
        {Object.keys(FILES)
          .filter((key) => details[key])
          .map((key) => (
            <Col md={3} className='mt-3' key={key}>
              {FILES[key]}: {fileLink(details[key])}
            </Col>
          ))}
      </Row>
      {details.coverLetter && (
        <Row className='mt-3'>
          <Col md={12} style={{whiteSpace: 'pre-wrap'}}>
            Cover Letter: {details.coverLetter}
          </Col>
        </Row>
      )}
      {Object.keys(ROWS)
        .filter((key) => details[key]?.length)
        .map((key) =>
          details[key].map((row: Record<string, any>, i: number) => (
            <Row key={`${key}-${row.id}`} className='mt-3'>
              <Col md={3}>
                {ROWS[key]} {i + 1}: {row.university || row.name || row.organizationName}
              </Col>
              {Object.keys(ROW_LABELS)
                .filter((field) => row[field])
                .map((field) => (
                  <Col md={3} key={field}>
                    {ROW_LABELS[field]}: {row[field]}
                  </Col>
                ))}
              {row.document && <Col md={3}>Document: {fileLink(row.document)}</Col>}
            </Row>
          ))
        )}
    </div>
  )
}

export default CareerDetails
